import removeSpaces from "./removeSpaces";

// The first segment of /product/:category/:name/:id tells the product page which
// item type to fetch. Keep these values in sync with resolveProductType below.
export const TYPE_SEGMENTS = {
  fabric: "woven",
  knit: "knits",
  stock: "stocks",
};

// Item type of the listing the user is currently browsing.
export const getCurrentTypeSegment = () => {
  if (localStorage.getItem("viewMode") === "stocks") return TYPE_SEGMENTS.stock;
  if (localStorage.getItem("isKnitsMode") === "true") return TYPE_SEGMENTS.knit;
  return localStorage.getItem("category") || TYPE_SEGMENTS.fabric;
};

// Reverse mapping used by the product page. Returns null when the segment is
// missing so the caller can fall back to localStorage.
export const resolveProductType = (segment) => {
  const value = (segment || "").toLowerCase();
  if (!value) return null;
  if (value === TYPE_SEGMENTS.stock) return "stock";
  if (value === TYPE_SEGMENTS.knit) return "knit";
  return "fabric";
};

// Always emits the 3 segment form so /product/:category/:name/:id matches.
export const buildProductUrl = (product, typeSegment) => {
  const segment = encodeURIComponent(typeSegment || getCurrentTypeSegment());
  const name = removeSpaces(product?.attributes?.fabric_name || "product");
  return `${process.env.PUBLIC_URL}/product/${segment}/${name}/${product.id}`;
};
